import React from 'react';
import PropTypes from 'prop-types';
import RecentQuery from 'ferries/Home/components/FerrySearchMask/PopularPortOverlay/RecentQuery';

const RecentSearches = ({queries, onClickQuery, translations}) => (
  <>
    <div className="grid-item-auto border-right mx-2 mt-6" />
    <div className="grid-item">
      <div className="mb-4 font-bold">{translations.recentSearches}</div>
      {queries.map((query, i) => (
        <RecentQuery
          key={i}
          query={query}
          wrapperClass="pl-3 py-2 mb-1 cursor-pointer"
          onClickQuery={onClickQuery}
          translations={translations}
        />
      ))}
    </div>
  </>
);

RecentSearches.propTypes = {
  queries: PropTypes.object.isRequired,
  onClickQuery: PropTypes.func.isRequired,
  translations: PropTypes.shape({
    recentSearches: PropTypes.string.isRequired
  })
};

export default RecentSearches;
